import styled from 'styled-components';
import { Input as InputCore } from '@salutejs/plasma-core';
import { applyInputStyles } from './mixins';
export var Input = /*#__PURE__*/styled(InputCore).withConfig({
  componentId: "plasma-web-core__sc-1r492xu-0"
})(["", ";height:var(--height);font-size:var(--font-size);line-height:var(--line-height);font-weight:var(--plasma-typo-body-m-font-weight);border-radius:var(--border-radius);&::placeholder{color:transparent;}"], applyInputStyles);